export enum SidebarItemType {
  Nested = 'nested',
}
